import wixWindow from 'wix-window';
let fadeOut = {
    "duration": 200,
    "delay": 0
};
// For full API documentation, including code examples, visit http://wix.to/94BuAAs



$w.onReady(function () {
	//TODO: write your page related code here...

});


export function lefttop_mouseIn(event) {
	$w('#eyeupleft').show('fade', fadeOut)
	//Add your code for this event here: 
}

export function lefttop_mouseOut(event) {
	$w('#eyeupleft').hide('fade', fadeOut)
	//Add your code for this event here: 
}

export function leftbottom_mouseIn(event) {
	$w('#eyeleftbottom').show('fade', fadeOut)
	//Add your code for this event here: 
}

export function leftbottom_mouseOut(event) {
	$w('#eyeleftbottom').hide('fade', fadeOut)
	//Add your code for this event here: 
}



export function righttop_mouseIn(event) {
	$w('#eyeupright1').show('fade', fadeOut)
	//Add your code for this event here: 
}

export function righttop_mouseOut(event) {
	$w('#eyeupright1').hide('fade', fadeOut)
	//Add your code for this event here: 
}

export function rightbottom_mouseIn(event) {
	$w('#eyerightdown').show('fade', fadeOut)
	//Add your code for this event here: 
}

export function rightbottom_mouseOut(event) {
	$w('#eyerightdown').hide('fade', fadeOut)
	//Add your code for this event here: 
}